import styled from 'styled-components';
import { Controlbar } from 'ui/Controlbar';
import { CONTROLBAR_VARIANTS } from 'ui/Controlbar/constants';
import { colors, zIndex } from 'ui/theme';
import { DateFilterMenu } from './DateFilterMenu';
import { DashboardFilter } from './DashboardFilter';

const StyledControlbar = styled(Controlbar)`
  &&&[data-variant=${CONTROLBAR_VARIANTS.PRIMARY}] {
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur(25px);
    box-shadow: none;
    z-index: ${zIndex.nav};

    &:after {
      border-bottom: 1px solid ${colors.borderPrimarySubtle};
      content: '';
      position: absolute;
      bottom: 0;
      /* Expand the border to the edges of the container */
      left: -2px;
      right: -2px; 
    }
  }
`;

export const HOME_PAGE_TOOLBAR_TEST_ID = 'homepage-toolbar';

export const Toolbar = ({ ...props }) => {
  return (
    <StyledControlbar
      aria-label="Toolbar"
      variant="primary"
      size="small"
      data-test={HOME_PAGE_TOOLBAR_TEST_ID}
      {...props}
    >
      <DashboardFilter />
      <DateFilterMenu />
    </StyledControlbar>
  );
};
